import { dateToReadableDay, dateToReadableTime } from '@/shared/datetime'
import { useRegistry } from '@/hooks'
import { cn } from '@ttab/elephant-ui/utils'
import type { LucideProps } from '@ttab/elephant-ui/icons'
import type { JSX } from 'react'

type Time = { time: Array<Date | string | undefined>, tooltip: string, type: string } | undefined

export const AssignmentTimeDisplay = ({ date, className, icon }: { date: Time, className?: string, icon: React.FC<LucideProps> }): JSX.Element => {
  const { locale, timeZone } = useRegistry()
  const Icon = icon

  function displayDay(time: Array<Date | string | undefined>): string {
    let timeValue
    if (typeof time[0] === 'object') {
      timeValue = time[0]
    }
    if (typeof time[0] === 'string') {
      timeValue = new Date(time[0])
    }
    if (!timeValue) {
      return ''
    }

    return dateToReadableDay(timeValue, locale.code.full, timeZone) || ''
  }

  return (
    <div className='flex flex-col text-left'>
      <div className={cn('font-medium text-sm select-none flex gap-1 items-center justify-start', className)}>
        {date?.type && ['picture', 'video'].includes(date.type) && <span>{displayDay(date.time)}</span>}
        {date?.time.map((timestamp, index) => (
          <span key={date.time.join('') + date.tooltip + index}>
            {typeof timestamp === 'object' ? dateToReadableTime(timestamp, locale.code.full, timeZone) : timestamp}
            {index < date.time.length - 1 && <span>{' - '}</span>}
          </span>
        ))}
        <Icon size={18} />
      </div>
      <span className='text-xs text-foreground/70'>{date?.tooltip}</span>
    </div>
  )
}
